var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-col',[_c('ProductCard',{key:_vm.product.Item_id,staticClass:"col-md-12",attrs:{"prodDetails":_vm.product,"filter":[]}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }